const ProfileEnum = Object.freeze({
  PATIENT: 'PATIENT',
  NURSE: 'NURSE',
  ADMINISTRATOR: 'ADMINISTRATOR',
});

export default ProfileEnum;
